import { render, staticRenderFns } from "./PianificaTest.vue?vue&type=template&id=072225ae&"
import script from "./PianificaTest.vue?vue&type=script&lang=js&"
export * from "./PianificaTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports